<template>
  <b-overlay :show="loading">
  <b-form data-vv-scope="bidder-form">
  <b-form-group
      label="Rut"
      label-for="iut"
      class="mb-3"
  >
    <b-form-input-rut
        id="iut"
        name="iut"
        data-cy="bidder-iut"
        placeholder="Rut"
        v-model="bidder.identification"
        :state="errors.has('bidder-form.iut') ? false : null"
        v-validate="'required|validateRut'"
        data-vv-as="Rut"
        :disabled="!!bidder.id"
    />
    <b-form-invalid-feedback>
      {{ errors.first('bidder-form.iut') }}
    </b-form-invalid-feedback>
  </b-form-group>
  <b-form-group
      data-vv-as="Nombre / razón social"
      label="Nombre / razón social"
      label-for="name"
      class="mb-3"
  >
    <b-form-input
        id="name"
        name="name"
        data-cy="bidder-name"
        placeholder="Nombre"
        data-vv-as="Nombre"
        v-model="bidder.name"
        :state="errors.has('bidder-form.name') ? false : null"
        v-validate="'required|max:100'"
    />
    <b-form-invalid-feedback>
      {{ errors.first('bidder-form.name') }}
    </b-form-invalid-feedback>
  </b-form-group>
  <b-form-group
      label="Giro"
      label-for="fantasyCompanyName"
      class="mb-3"
  >
    <b-form-input
        id="giro"
        name="giro"
        data-cy="bidder-giro"
        data-vv-as="Giro"
        placeholder="Giro"
        v-model="bidder.giro"
        :state="errors.has('bidder-form.giro') ? false : null"
        v-validate="'required|max:40'"
    />
    <b-form-invalid-feedback>
      {{ errors.first('bidder-form.giro') }}
    </b-form-invalid-feedback>
  </b-form-group>
  <b-form-group
      label="Dirección"
      label-for="address"
      class="mb-3"
  >
    <b-form-input
        id="address"
        name="address"
        data-cy="bidder-address"
        data-vv-as="Dirección"
        placeholder="Dirección"
        v-model="bidder.address"
        :state="errors.has('bidder-form.address') ? false : null"
        v-validate="'required|max:80'"
    />
    <b-form-invalid-feedback>
      {{ errors.first('bidder-form.address') }}
    </b-form-invalid-feedback>
  </b-form-group>
  <b-form-group
      label="Comuna"
      label-for="commune"
      class="mb-3"
  >
    <b-form-input
        data-vv-as="Comuna"
        id="commune"
        name="commune"
        data-cy="bidder-commune"
        placeholder="Comuna"
        v-model="bidder.commune"
        :state="errors.has('bidder-form.commune') ? false : null"
        v-validate="'required|max:20'"
    />
    <b-form-invalid-feedback>
      {{ errors.first('bidder-form.commune') }}
    </b-form-invalid-feedback>
  </b-form-group>
  <b-form-group
      label="Ciudad"
      label-for="city"
      class="mb-3"
  >
    <b-form-input
        data-vv-as="Ciudad"
        id="city"
        name="city"
        data-cy="bidder-city"
        placeholder="Ciudad"
        v-model="bidder.city"
        :state="errors.has('bidder-form.city') ? false : null"
        v-validate="'required|max:20'"
    />
    <b-form-invalid-feedback>
      {{ errors.first('bidder-form.city') }}
    </b-form-invalid-feedback>
  </b-form-group>
  <b-form-group
      label="Correo"
      label-for="email"
      class="mb-3"
  >
    <b-form-input
        data-vv-as="Correo"
        id="email"
        name="email"
        data-cy="bidder-email"
        placeholder="Correo"
        v-model="bidder.email"
        :state="errors.has('bidder-form.email') ? false : null"
        v-validate="'required|email|max:80'"
    />
    <b-form-invalid-feedback>
      {{ errors.first('bidder-form.email') }}
    </b-form-invalid-feedback>
  </b-form-group>
  <b-form-group
      label="Contacto"
      label-for="contact"
      class="mb-3"
  >
    <b-form-input
        data-vv-as="Contacto"
        id="contact"
        name="contact"
        placeholder="Escriba en formato +56912345678"
        data-cy="bidder-contact"
        v-validate="{ required: true, regex: phoneRegex }"
        v-model="bidder.phone"
        :state="errors.has('bidder-form.contact') ? false : null"
    />
    <b-form-invalid-feedback>
      {{ errors.first('bidder-form.contact') }}
    </b-form-invalid-feedback>
  </b-form-group>
  <div class="text-right">
    <b-button
        @click="createBidder()"
        variant="primary"
        class="mr-1 text-right"
        data-cy="next-button"
    >
      Guardar
    </b-button>
  </div>
  </b-form>
  </b-overlay>
</template>
<script>
import { mapActions } from 'vuex';

import { successfulBiddersCreate, successfulBiddersUpdate } from '@/febos/servicios/api/aduanas/successfulBidders';
import BFormInputRut from '@/components/inputs/BFormInputRut';

export default {
  components: {
    BFormInputRut
  },
  props: {
    actualBidder: {
      type: Object,
      default: () => ({
        type: '',
        name: '',
        identification: '',
        passport: '',
        country: '',
        address: '',
        commune: '',
        city: '',
        region: '',
        phone: '',
        email: '',
        giro: ''
      })
    }
  },
  data() {
    return {
      // eslint-disable-next-line
      phoneRegex: /^[\+][0-9]{10,11}$/,
      loading: false,
      bidder: {
        type: '',
        name: '',
        identification: '',
        passport: '',
        country: '',
        address: '',
        commune: '',
        city: '',
        region: '',
        phone: '',
        email: '',
        giro: '',
        ...this.actualBidder
      }
    };
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ]),
    async createBidder() {
      const result = await this.$validator.validateAll('bidder-form');
      if (!result) {
        return;
      }
      this.loading = true;
      try {
        if (this.bidder.id) {
          const { data } = await successfulBiddersUpdate(this.bidder);
          await this.$emit('bidder-save', { ...data, action: 'update' });
        } else {
          const { data } = await successfulBiddersCreate(this.bidder);
          await this.$emit('bidder-save', { ...data, action: 'create' });
        }
      } finally {
        this.loading = false;
      }
    },
    initBidder() {
      if (this.actualBidder) {
        this.bidder = {
          identification: this.actualBidder.rut,
          id: this.actualBidder.adjudicatarioId,
          email: this.actualBidder.correo,
          commune: this.actualBidder.comuna,
          address: this.actualBidder.direccion,
          type: this.actualBidder.tipo,
          name: this.actualBidder.nombre,
          passport: this.actualBidder.passport,
          country: this.actualBidder.country,
          city: this.actualBidder.ciudad,
          region: this.actualBidder.region,
          phone: this.actualBidder.telefono,
          giro: this.actualBidder.giro
        };
      } else {
        this.bidder = {};
      }
    }
  },
  created() {
    this.initBidder();
  }
};
</script>
